import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, Modal } from "react-bootstrap";
import { profileService, authService } from "../services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import UpdatePassword from "./UpdatePassword";
import moment from "moment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import countries from "../utils/wp_country.json";

function Profile() {
  const [profileData, setProfileData] = useState({
    userId: "",
    firstName: "",
    surName: "",
    email: "",
    referCode: "",
    phone: "",
    phoneCode: "+44",
    phoneNumber: "", // Default phone code
    dob: "",
    isContactBySMS: false,
    isContactByEmail: false,
    isContactByAppNotification: false,
    specialityList: [],
    cuisineList: [],
    locationList: [],
  });

  const [showModal, setShowModal] = useState(false);

  const [interestList, setInterestList] = useState([]);
  const [cuisinesList, setCuisinesList] = useState([]);
  const [locationList, setLocationList] = useState([]);

  const [selectAll, setSelectAll] = useState(false);
  const [errors, setErrors] = useState({});

  const [selectedPhoneCode, setSelectedPhoneCode] = useState("+44");
  const [showNumberModal, setShowNumberModal] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCountryId, setSelectedCountryId] = useState(null);

  useEffect(() => {
    getProfileData();

    getInterestList();
    getCuisinesList();
    GetAllLocationsAPI();
  }, []);

  // Fetch Profile Data
  const getProfileData = async () => {
    try {
      const res = await profileService.getProfileDetails();
      if (res && res.data) {
        const {
          userId,
          firstName,
          surName,
          email,
          referCode,
          phone,
          dob,
          specialityList,
          cuisineList,
          locationList,
          isContactBySMS,
          isContactByEmail,
          isContactByAppNotification,
        } = res.data;

        const splitPhone = phone?.startsWith("+")
          ? phone.split(" ")
          : ["+44", phone];

        setProfileData({
          userId,
          firstName,
          surName,
          email,
          referCode,
          phoneCode: splitPhone[0],
          phone: splitPhone[1],
          dob: dob ? moment(dob, "DD/MM/YYYY").format("YYYY-MM-DD") : "",

          isContactBySMS,
          isContactByEmail,
          isContactByAppNotification,

          specialityList,
          cuisineList,
          locationList,
        });
        // 👇 Set Select All based on values from backend
        const allSelected =
          isContactByEmail && isContactBySMS && isContactByAppNotification;

        setSelectAll(allSelected);
      }
    } catch (error) {
      toast.error("Error fetching profile data");
    }
  };

  // Fetch Interest List
  const getInterestList = async () => {
    try {
      const res = await authService.getInterestList();
      if (res && res.data) {
        setInterestList(res.data);
      }
    } catch (error) {
      toast.error("Error fetching interest list");
    }
  };

  // Fetch Cuisines List
  const getCuisinesList = async () => {
    try {
      const res = await authService.getCuisinesList();
      if (res && res.data) {
        setCuisinesList(res.data);
      }
    } catch (error) {
      console.log("Error fetching cuisines list");
    }
  };

  // Fetch Location List
  const GetAllLocationsAPI = async () => {
    try {
      const payload = {
        userId: "string",
        pageNumber: 1,
        pageSize: 100,
      };
      const res = await authService.GetAllLocationsAPI(payload);
      if (res && res.data) {
        const filteredLocations = res.data.locationList
          .filter((loc) => loc.locationName?.trim())
          .sort((a, b) =>
            a.locationName.localeCompare(b.locationName, undefined, {
              sensitivity: "base",
            })
          );
        setLocationList(filteredLocations);
      }
    } catch (error) {
      console.log("Error fetching location list");
    }
  };

  // ******* Handle-Change ***********
  const handleChange = (e) => {
    const { name, value } = e.target;
    let processedValue = value;
    let errorMsg = "";

    if (name === "firstName" || name === "surName") {
      processedValue = value.replace(/[^a-zA-Z ]/g, "");
      if (processedValue.trim() === "") {
        errorMsg = `${
          name === "firstName" ? "First Name" : "Surname"
        } is required`;
      }
    }

if (name === "phone") {
  processedValue = value.replace(/\D/g, ""); 

  if (processedValue.trim() === "") {
    errorMsg = "Phone number is required";
  } 
  //  else if (processedValue.startsWith("0")) {
  //   errorMsg = "Phone number cannot start with 0";
  // } 
  else if (processedValue.length < 7 || processedValue.length > 11) {
    errorMsg = "Phone number must be 7 to 11 digits";
  }
}

    // if (name === "dob") {
    //   const age = moment().diff(moment(value, "YYYY-MM-DD"), "years");
    //   if (!value) {
    //     errorMsg = "Date of birth is required";
    //   } else if (age < 18) {
    //     errorMsg = "Must be at least 18 years old";
    //   }
    // }

    if (name === "dob") {
      const age = dayjs().diff(dayjs(value, "YYYY-MM-DD"), "years");
      if (!value) {
        errorMsg = "Date of birth is required";
      } else if (age < 18) {
        errorMsg = "Must be at least 18 years old";
      }
    }

    setErrors({ ...errors, [name]: errorMsg });
    setProfileData({ ...profileData, [name]: processedValue });
  };

  // ******* Get Handle DAte change *********
  const handleDateChange = (newValue) => {
    const rawDate = newValue ? dayjs(newValue).format("YYYY-MM-DD") : "";

    let errorMsg = "";
    const age = dayjs().diff(dayjs(rawDate, "YYYY-MM-DD"), "years");

    if (!rawDate) {
      errorMsg = "Date of birth is required";
    } else if (age < 18) {
      errorMsg = "Must be at least 18 years old";
    }

    setErrors((prevErrors) => ({ ...prevErrors, dob: errorMsg }));
    setProfileData((prevData) => ({ ...prevData, dob: rawDate }));
  };

  // ******* 18+ Date validation ***********
  const getMaxDateFor18Plus = () => {
    return moment().subtract(18, "years").format("YYYY-MM-DD");
  };

  // Handle Checkbox Change
  const handleCheckboxChange = (e, listName, id) => {
    const { checked } = e.target;

    setProfileData((prevData) => {
      const updatedList = checked
        ? [...(prevData[listName] || []), { id }]
        : prevData[listName].filter((item) => item.id !== id);

      return {
        ...prevData,
        [listName]: updatedList,
      };
    });
  };

  // Contact_APi_Call
  const handleUpdateContact = async () => {
    const newErrors = {};
    const fullPhone = `${profileData.phoneCode} ${profileData.phone}`;

    if (!profileData.firstName.trim()) {
      newErrors.firstName = "First Name is required";
    }

    if (!profileData.surName.trim()) {
      newErrors.surName = "Surname is required";
    }

    if (!profileData.phone.trim()) {
      newErrors.phone = "Phone number is required";
    } else if (profileData.phone.length < 7 || profileData.phone.length > 11) {
      newErrors.phone = "Phone number must be 7 to 11 digits";
    }

    if (!profileData.dob) {
      newErrors.dob = "Date of birth is required";
    } else {
      const age = moment().diff(moment(profileData.dob, "YYYY-MM-DD"), "years");
      if (age < 18) {
        newErrors.dob = "Must be at least 18 years old";
      }
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors); // Show validation messages
      return; // Stop API call
    }

    try {
      const formattedDOB = moment(profileData.dob, "YYYY-MM-DD").format(
        "MM/DD/YYYY"
      );

      // const fullPhone = `${profileData.phoneCode} ${profileData.phone}`;
      let cleanedPhone = profileData.phone;
        if (cleanedPhone.startsWith("0")) {
          cleanedPhone = cleanedPhone.substring(1); // remove only the first character
        }
        const fullPhone = `${profileData.phoneCode} ${cleanedPhone}`;


      const response = await profileService.contactUpdate({
        userId: profileData.userId,
        firstName: profileData.firstName,
        surName: profileData.surName,
        // phone: profileData.phone,
        phone: fullPhone,
        referCode: "",
        dob: formattedDOB,
      });

      if (response && response.success) {
        toast.success(response.message);
      } else {
        toast.error("Failed to update contact details.");
      }
    } catch (error) {
      toast.error("Error updating contact details");
    }
  };

  // Preference_API_Call
  const handleUpdatePreferences = async () => {
    try {
      const response = await profileService.preferencesUpdate({
        userId: profileData.userId,
        specialityList:
          profileData.specialityList?.map((item) => item.id) || [],
        cuisineList: profileData.cuisineList?.map((item) => item.id) || [],
        locationList: profileData.locationList?.map((item) => item.id) || [],
        dietaryList: [],
        isContactBySMS: profileData.isContactBySMS,
        isContactByEmail: profileData.isContactByEmail,
        isContactByAppNotification: profileData.isContactByAppNotification,
      });

      if (response && response.success) {
        toast.success(response.message);
      } else {
        toast.error("Failed to update preferences.");
      }
    } catch (error) {
      toast.error("Error updating preferences:", error);
    }
  };

  // Select All
  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);
    setProfileData((prev) => ({
      ...prev,
      isContactByEmail: isChecked,
      isContactBySMS: isChecked,
      isContactByAppNotification: isChecked,
    }));
  };

  // Handle Change preference
  const handlePreferenceChange = (e) => {
    const { name, checked } = e.target;
    setProfileData((prev) => {
      const updated = { ...prev, [name]: checked };
      const allSelected =
        updated.isContactByEmail &&
        updated.isContactBySMS &&
        updated.isContactByAppNotification;

      setSelectAll(allSelected);

      return updated;
    });
  };

  //  Loaction Button toggel
  const toggleLocation = (location) => {
    const isSelected = profileData.locationList.some(
      (loc) => loc.id === location.id
    );

    let updatedList = isSelected
      ? profileData.locationList.filter((loc) => loc.id !== location.id)
      : [...profileData.locationList, location];

    setProfileData((prev) => ({
      ...prev,
      locationList: updatedList,
    }));
  };

  // Handle Country select
  const handleCountrySelect = (country) => {
    setProfileData((prev) => ({
      ...prev,
      phoneCode: country.phonecode,
      countryId: country.id,
    }));
    setShowNumberModal(false);
  };

  // Filtered country list based on search
  const filteredCountries = countries?.countries?.filter((country) =>
    country.nicename.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div>
      <Card className="profile-card custom-dsign1">
        <Card.Body className="custom-dsign2">
          <h4>Profile</h4>
          <h3>Contact Details</h3>

          {/* Contact Details */}
          <Form>
            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>First Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="firstName"
                    value={profileData.firstName}
                    onChange={handleChange}
                    maxLength={50}
                    onInput={(e) => {
                      let value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                      e.target.value = value;
                    }}
                  />
                  {errors.firstName && (
                    <div className="text-danger">{errors.firstName}</div>
                  )}
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Surname*</Form.Label>
                  <Form.Control
                    type="text"
                    name="surName"
                    value={profileData.surName}
                    onChange={handleChange}
                    maxLength={50}
                    onInput={(e) => {
                      let value = e.target.value.replace(/[^A-Za-z\s]/g, "");
                      value = value.charAt(0).toUpperCase() + value.slice(1);
                      e.target.value = value;
                    }}
                  />
                  {errors.surName && (
                    <div className="text-danger">{errors.surName}</div>
                  )}
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Email*</Form.Label>
                  <Form.Control
                    disabled
                    type="email"
                    name="email"
                    value={profileData.email}
                    onChange={handleChange}
                  />
                </Form.Group>
              </Col>

              <Col md={6}>
                <div className="two-number">
                  <Form.Group>
                    <div className="two-number4">
                      <Form.Label> Phone Number*</Form.Label>
                      <div className="popup-i-bt1">
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-light i-bt11"
                          onClick={() => setShowModal(true)}
                        >
                          i
                        </button>
                      </div>
                    </div>

                    <div className="two-number2">
                      <div className="two-number3">
                        <Form.Control
                          type="text"
                          // placeholder={selectedPhoneCode}
                          value={profileData.phoneCode}
                          onClick={() => {
                            setShowNumberModal(true);
                          }}
                        />
                      </div>
                      <Form.Control
                        type="text"
                        name="phone"
                        value={profileData.phone}
                        onChange={handleChange}
                        maxLength={11}
                      />
                    </div>
                    {errors.phone && (
                      <div className="text-danger">{errors.phone}</div>
                    )}
                  </Form.Group>
                </div>
              </Col>
            </Row>

            {/* <Row>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    name="dob"
                    value={profileData.dob}
                    onChange={handleChange}
                    placeholder="DD/MM/YYYY"
                    max={getMaxDateFor18Plus()}
                  />
                </Form.Group>
              </Col>
            </Row> */}

            <Row>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Col md={6}>
                  <Form.Group>
                    <Form.Label>Date of Birth</Form.Label>
                    
                    <div className="prfofiledatepicker">
                    <DesktopDatePicker
                      value={
                        profileData.dob
                          ? dayjs(profileData.dob, "YYYY-MM-DD")
                          : null
                      }
                      onChange={handleDateChange}
                      format="DD/MM/YYYY"
                      maxDate={dayjs().subtract(18, "years")}
                      disableMaskedInput
                      className="dateprofile"
                      slotProps={{
                        textField: {
                          variant: "standard",
                          fullWidth: true,
                    
                          InputProps: {
                            disableUnderline: true,
                            // className: "dateProfilepickerinput",
                            classes: { root: "custom-date-root", input: "dateProfilepickerinput" },
                          },
                        },
                      }}
                    />
                    </div>
                  </Form.Group>
                </Col>
              </LocalizationProvider>
            </Row>
            

            <div className="profile-all-click-bt">
              <Button
                variant="primary"
                className="mt-3"
                onClick={handleUpdateContact}
              >
                Update Contact Details
              </Button>
            </div>
          </Form>

          {/* Change Password */}
          <UpdatePassword userId={profileData.userId} />

          {/* Preferences */}
          <Form className="profilePreferences">
            {/* <h4>Profile</h4> */}
            <h3>Special Interests</h3>
            <p>Check all that apply</p>
            <Row className="profileRow">
              {interestList.map((interest) => (
                <Col md={3} key={interest.id}>
                  <Form.Check
                    // className="form-check-input"
                    type="checkbox"
                    label={interest.specilityName}
                    checked={
                      profileData.specialityList?.some(
                        (speciality) => speciality.id === interest.id
                      ) || false
                    }
                    onChange={(e) =>
                      handleCheckboxChange(e, "specialityList", interest.id)
                    }
                  />
                </Col>
              ))}
            </Row>

            <h3 className="cuisines-fav1">Favourite Cuisines</h3>
            <p>Check all that apply</p>
            <Row className="profileRow">
              {cuisinesList.map((cuisine) => (
                <Col md={3} key={cuisine.id}>
                  <Form.Check
                    type="checkbox"
                    label={cuisine.cusineName}
                    checked={
                      profileData.cuisineList?.some(
                        (cuisines) => cuisines.id === cuisine.id
                      ) || false
                    }
                    onChange={(e) =>
                      handleCheckboxChange(e, "cuisineList", cuisine.id)
                    }
                  />
                </Col>
              ))}
            </Row>

            <h3 className="cuisines-fav1">Favourite Locations</h3>
            <p>
              Which restaurants you would like to receive news and offers from?
            </p>
            <div style={{ display: "flex", flexWrap: "wrap" }}>
              {locationList.map((location) => {
                const isSelected = profileData.locationList.some(
                  (loc) => loc.id === location.id
                );

                return (
                  <div
                    key={location.id}
                    className={`location-button ${
                      isSelected ? "selected" : ""
                    }`}
                    onClick={() => toggleLocation(location)}
                  >
                    {location.locationName}
                  </div>
                );
              })}
            </div>

            <div className="rewards-signup profile-edite">
              {/* Description */}
              <div className="text-center text-white mb-4">
                <h2>How would you like us to communicate with you?</h2>
              </div>

              {/* CheckBox */}
              <div className="row">
                <div className="col-sm-12 col-lg-5">
                  <div className="label-text12">
                    <h5 className="text-white text-start">Opt in for all</h5>
                    <div className="form-check form-switch like-bg">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={selectAll}
                        onChange={handleSelectAll}
                      />
                      <label
                        className="form-check-label text-white"
                        htmlFor="selectAll"
                      >
                        Select All
                      </label>
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-lg-7">
                  <h6 className="text-white text-start">
                    Get short, time-sensitive alerts about special promotions or
                    last-minute offers:
                  </h6>

                  <div className="three-check-box">
                    <div className="form-check form-switch like-bg">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        // id="isContactByEmail"
                        name="isContactByEmail"
                        checked={profileData.isContactByEmail}
                        onChange={handlePreferenceChange}
                      />
                      <label
                        className="form-check-label text-white"
                        htmlFor="email"
                      >
                        By Email
                      </label>
                    </div>

                    <div className="form-check form-switch like-bg">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        // id="sms"
                        name="isContactBySMS"
                        checked={profileData.isContactBySMS}
                        onChange={handlePreferenceChange}
                      />
                      <label
                        className="form-check-label text-white"
                        htmlFor="sms"
                      >
                        By SMS Alert
                      </label>
                    </div>

                    <div className="form-check form-switch like-bg">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        name="isContactByAppNotification"
                        checked={profileData.isContactByAppNotification}
                        onChange={handlePreferenceChange}
                      />
                      <label
                        className="form-check-label text-white"
                        htmlFor="app"
                      >
                        By App Notifications
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="profile-all-click-bt">
              <Button
                variant="primary"
                className="mt-3"
                onClick={handleUpdatePreferences}
              >
                Update Preferences
              </Button>
            </div>
          </Form>
        </Card.Body>
      </Card>

      {/* Modal */}
      <Modal
        className="design222"
        show={showModal}
        onHide={() => setShowModal(false)}
        centered
      >
        <div className="all-modal-design">
          <div className="iconIII">
            <button className="modelibutton">i</button>
          </div>

          <h4>Why do we need your phone number?</h4>
          <p>
            So we can keep you updated about your reservation. It is also
            required to make a booking.
          </p>
          <button
            className="btn btn-primary"
            onClick={() => setShowModal(false)}
          >
            UNDERSTOOD
          </button>
        </div>
      </Modal>

      {/* Model For Country code*/}
      {/* Country Selection Modal */}
      {showNumberModal && (
        <Modal
          className="design222 numb oneup"
          show={showNumberModal}
          onHide={() => setShowNumberModal(false)}
          centered
        >
          <Modal.Body className="p-3">
            {/* Search Box */}
            <input
              type="text"
              className="form-control mb-3"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />

            {/* Scrollable Country List */}
            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
              {filteredCountries.map((country) => (
                <div
                  key={country.id}
                  className="d-flex justify-content-between align-items-center py-2 border-bottom"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleCountrySelect(country)}
                >
                  <div>
                    <div style={{ fontWeight: "bold" }}>{country.nicename}</div>
                    <div style={{ fontSize: "12px", color: "#888" }}>
                      {country.phonecode}
                    </div>
                  </div>
                  {profileData.countryId === country.id && (
                    <div style={{ fontSize: "20px", color: "green" }}>✔️</div>
                  )}
                </div>
              ))}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
}

export default Profile;
